import { Box } from "@mui/material";
import style from "./style.module.scss";

interface IProps {
  page: string;
}

export default function Subheader(props: IProps) {
  return (
    <Box className={style.subheader}>
      <Box className={style.page}>{props.page}</Box>
      <Box className={style.options}></Box>
    </Box>
  );
}
